module.exports = __webpack_public_path__ + "static/access_handbook_new_395x386-52edb7d673360d63e62221ee3df65c6a.webp";